// Client-side generation of acceptance letters and payment receipts (print to PDF).
const PUBLISHER = "Noventra Academic Press";

function fmtDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" });
}

function shell(title, inner) {
  return `<!doctype html><html><head><meta charset="utf-8"><title>${title}</title>
  <style>
    body{font-family:Georgia,'Times New Roman',serif;color:#0f172a;max-width:720px;margin:40px auto;padding:0 32px;line-height:1.6}
    .brand{font-family:Arial,sans-serif;text-transform:uppercase;letter-spacing:3px;font-size:12px;color:#D97706;font-weight:700}
    h1{color:#0F2C59;font-size:26px;margin:4px 0 24px}
    .row{display:flex;justify-content:space-between;border-bottom:1px solid #e2e8f0;padding:8px 0;font-family:Arial,sans-serif;font-size:14px}
    .row span:first-child{color:#64748b}
    .sig{margin-top:40px;font-size:14px;color:#334155}
    .foot{margin-top:40px;border-top:1px solid #e2e8f0;padding-top:12px;font-size:11px;color:#94a3b8;font-family:Arial,sans-serif}
    @media print{body{margin:0}}
  </style></head><body>${inner}
  <div class="foot">${PUBLISHER} · Open Access Peer-Reviewed International Journals. This document was generated electronically.</div>
  </body></html>`;
}

export function openPrintable(title, innerHtml) {
  const w = window.open("", "_blank");
  if (!w) return;
  w.document.write(shell(title, innerHtml));
  w.document.close();
  w.focus();
  setTimeout(() => w.print(), 500);
}

export function acceptanceLetterHtml(paper) {
  const authors = (paper.authors || []).map((a) => a.name).join(", ");
  const corr = paper.authors?.find((a) => a.is_corresponding) || paper.authors?.[0] || {};
  return `
  <div class="brand">${PUBLISHER}</div>
  <h1>Letter of Acceptance</h1>
  <p>Date: ${fmtDate(new Date().toISOString())}</p>
  <p>Dear ${corr.name || "Author"},</p>
  <p>We are pleased to inform you that your manuscript titled
  <strong>&ldquo;${paper.title}&rdquo;</strong> (Submission ID: <strong>${paper.submission_id || paper.id}</strong>)
  has been <strong>accepted</strong> for publication in <em>${paper.journal?.title || "our journal"}</em>
  following peer review.</p>
  <div class="row"><span>Authors</span><span>${authors}</span></div>
  <div class="row"><span>Journal</span><span>${paper.journal?.title || ""}</span></div>
  <div class="row"><span>Article Type</span><span>${paper.article_type || ""}</span></div>
  ${paper.doi ? `<div class="row"><span>DOI</span><span>${paper.doi}</span></div>` : ""}
  <p style="margin-top:20px">Thank you for choosing ${PUBLISHER}. We look forward to publishing your work.</p>
  <div class="sig">Sincerely,<br/><strong>${paper.journal?.editor_in_chief || "The Editorial Office"}</strong><br/>${paper.journal?.title || PUBLISHER}</div>`;
}

export function receiptHtml(paper) {
  const corr = paper.authors?.find((a) => a.is_corresponding) || paper.authors?.[0] || {};
  const apc = paper.journal?.apc || "$0";
  return `
  <div class="brand">${PUBLISHER}</div>
  <h1>Payment Receipt</h1>
  <div class="row"><span>Receipt No.</span><span>RCPT-${(paper.submission_id || paper.id).toString().replace(/[^\w-]/g, "")}</span></div>
  <div class="row"><span>Date</span><span>${fmtDate(new Date().toISOString())}</span></div>
  <div class="row"><span>Billed To</span><span>${corr.name || "Author"}</span></div>
  <div class="row"><span>Submission ID</span><span>${paper.submission_id || paper.id}</span></div>
  <div class="row"><span>Article</span><span>${paper.title}</span></div>
  <div class="row"><span>Journal</span><span>${paper.journal?.title || ""}</span></div>
  <div class="row"><span>Description</span><span>Article Processing Charge (APC)</span></div>
  <div class="row"><span><strong>Amount Paid</strong></span><span><strong>${apc}</strong></span></div>
  <div class="row"><span>Status</span><span style="color:#16a34a">PAID</span></div>
  <p style="margin-top:20px;font-size:13px;font-family:Arial,sans-serif;color:#64748b">This is a demonstration receipt generated by the platform and does not represent a real financial transaction.</p>`;
}
